import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23942029"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "popup-window"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Upload new template", -1))
const _hoisted_3 = { class: "input-div" }
const _hoisted_4 = { class: "input-div" }
const _hoisted_5 = { class: "input-div" }
const _hoisted_6 = { class: "result-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.visible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createTextVNode(" name: "),
            _withDirectives(_createElementVNode("input", {
              class: "input-box",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event))
            }, null, 512), [
              [_vModelText, _ctx.name]
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createTextVNode("id: "),
            _withDirectives(_createElementVNode("input", {
              class: "input-box",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.id) = $event))
            }, null, 512), [
              [_vModelText, _ctx.id]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createTextVNode(" Image: "),
            _createElementVNode("input", {
              type: "file",
              accept: "image/jpeg,image/png",
              onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.uploadImage && _ctx.uploadImage(...args)))
            }, null, 32)
          ]),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.resText), 1),
          _createElementVNode("button", {
            class: "rectangle-button",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.uploadWorkspace()))
          }, "Upload")
        ]))
      : _createCommentVNode("", true),
    (_ctx.visible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "dialog-bg center",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.exit()))
        }))
      : _createCommentVNode("", true)
  ], 64))
}